import { Injectable } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';

@Injectable({
    providedIn: 'root',
})
export class UtilsService {
    constructor(private _translateService: CustomTranslateService) {}

    public numFormatter(num: number, factor?: number | undefined): string {
        let language: string = this._translateService.currentLang;

        num = Number(num);

        if (factor) num *= factor;

        let isNegative: boolean = num < 0;

        if (isNegative) num = -num;

        if (num < 100) {
            if (num < 0.01 && num > 0) {
                return !isNegative ? '0.00...' : '- 0.00...';
            }
            return !isNegative
                ? (+num.toFixed(2)).toLocaleString(language)
                : `- ${(+num.toFixed(2)).toLocaleString(language)}`;
        }
        if (num < 1000) {
            if (num >= 999.5) {
                return !isNegative
                    ? `${(+(num / 1000).toFixed(0)).toLocaleString(language)} k`
                    : `- ${(+(num / 1000).toFixed(0)).toLocaleString(language)} k`;
            }
            return !isNegative
                ? (+num.toFixed(0)).toLocaleString(language)
                : `- ${(+num.toFixed(0)).toLocaleString(language)}`;
        }
        const sizes: string[] = ['k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
        let power: number = 0;
        for (let index in sizes) {
            power += 3;
            if (num < Math.pow(10, power + 3)) {
                if (num / Math.pow(10, power) < 100) {
                    return !isNegative
                        ? `${(+(num / Math.pow(10, power)).toFixed(2)).toLocaleString(language)} ${sizes[index]}`
                        : `- ${(+(num / Math.pow(10, power)).toFixed(2)).toLocaleString(language)} ${sizes[index]}`;
                }
                if (num / Math.pow(10, power) >= 999.5) {
                    return !isNegative
                        ? `${(+(num / Math.pow(10, power + 3)).toFixed(0)).toLocaleString(language)} ${
                              sizes[Number.parseInt(index) + 1]
                          }`
                        : `- ${(+(num / Math.pow(10, power + 3)).toFixed(0)).toLocaleString(language)} ${
                              sizes[Number.parseInt(index) + 1]
                          }`;
                }
                return !isNegative
                    ? `${(+(num / Math.pow(10, power)).toFixed(0)).toLocaleString(language)} ${sizes[index]}`
                    : `- ${(+(num / Math.pow(10, power)).toFixed(0)).toLocaleString(language)} ${sizes[index]}`;
            }
        }
        return !isNegative
            ? `${(+(num / Math.pow(10, power)).toFixed(0)).toLocaleString(language)} Y`
            : `- ${(+(num / Math.pow(10, power)).toFixed(0)).toLocaleString(language)} Y`;
    }
    // 0,001 t Piles et batteries = 0,0036 t CO2
    public simpleNumFormatter(
        num: number,
        factor: number | undefined = undefined,
        digits: number | undefined = undefined,
    ): string {
        if (num !== undefined) {
            if (factor) num *= factor;
            let language: string = this._translateService.currentLang;
            if (digits !== undefined) {
                num = num < 0.0001 && num > 0 ? 0.0001 : num > -0.0001 && num < 0 ? -0.0001 : num;
                return num.toLocaleString(language, { maximumFractionDigits: digits });
            }
            if (num < 100) {
                if (num < 0.01 && num > 0) {
                    return '0.00...';
                }
                return num.toLocaleString(language, { maximumFractionDigits: 2 });
            }
            return num.toLocaleString(language, { maximumFractionDigits: 0 });
        } else {
            return '';
        }
    }

    public capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    public formatStringLength(entry: string | undefined, length: number): string {
        if (entry === undefined) return '';
        else if (entry.length <= length) return entry;
        else return `${entry.substring(0, length - 1)}...`;
    }

    public handleTranslation(translation: string | string[]) {
        return Array.isArray(translation) ? translation[0] : translation;
    }
}
